import {useSuspenseQuery} from '@tanstack/react-query'
import {shopQueryOptions} from '~/client/fn/shop'

const useShopConfig = () => {
    const query = useSuspenseQuery(shopQueryOptions())
    return query.data
}

export default useShopConfig
